import { FC } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import Slider from 'react-slick';
import platinx from 'src/components/logos/platinx.png';
import bybit from 'src/components/logos/bybit.png';
import stepmint from 'src/components/logos/stepmint.png';
import mrmint from 'src/components/logos/mrmint.png';
import hurupay from 'src/components/logos/hurupay.png';
import mudrex from 'src/components/logos/mudrex.png';
import coinswitch from 'src/components/logos/coinswitch.jpeg';
import zynklab from 'src/components/logos/zynklab.png';

const trustedClients = [
  { name: 'Platinx', logo: platinx },
  { name: 'Bybit', logo: bybit },
  { name: 'Stepmint', logo: stepmint },
  { name: 'Mr Mint', logo: mrmint },
  { name: 'Hurupay', logo: hurupay },
  { name: 'Mudrex', logo: mudrex },
  { name: 'CoinSwitch', logo: coinswitch },
  { name: 'ZynkLab', logo: zynklab}
];

export const HomeTrustedClient: FC = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: isMdUp ? 5 : 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <Box
      component="section"
      className="trusted-client-section"
      sx={{
        width: '100%',
        height: '30vh',
        // backgroundColor: theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.100',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        px: { xs: 2, md: 4 },
        overflow: 'hidden',
        mt:'50px',
        mb: '50px',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: 'text.secondary',
          fontWeight: 700,
          fontSize: '1.5rem',
          letterSpacing: 1,
          mb:5,
          mt:4,
          textAlign: 'center',
        }}
      >
        Trusted by Global Enterprises
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: 1200,
        }}
      >
        <Slider {...settings}>
          {trustedClients.map((client) => (
            <Box
              key={client.name}
              sx={{
                display: 'flex',
                alignItems: 'flex-end', // Align all images to the baseline
                justifyContent: 'center',
                px: 2,
                height: 120, // Ensure all boxes have the same height
              }}
            >
                <img
                  src={client.logo}
                  alt={client.name}
                  style={{
                    height: '100px',
                    width: 'auto',
                    maxWidth: '160px',
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                    transition: 'transform 0.3s ease-in-out',
                    filter:
                      theme.palette.mode === 'dark'
                        ? client.name === 'Platinx'
                          ? 'none' // keep golden in dark mode
                          : 'invert(1) brightness(2)' // white logos
                        : 'grayscale(40%)', // light mode style
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.filter = 'none'; // full color on hover
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.filter =
                      theme.palette.mode === 'dark'
                        ? client.name === 'Platinx'
                          ? 'none'
                          : 'invert(1) brightness(2)'
                        : 'grayscale(40%)';
                  }}
                />


            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};
